import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, BookOpen, Globe, Users, Award, TrendingUp, Target, GraduationCap, Star } from 'lucide-react';

const HomePage = () => {
  const stats = [
    { number: "5", label: "Países", sublabel: "Con docentes certificados" },
    { number: "150", label: "Instituciones", sublabel: "Aliadas globalmente" },
    { number: "2500", label: "Docentes", sublabel: "Certificados exitosamente" },
    { number: "10000", label: "Estudiantes", sublabel: "Beneficiados por docentes GRANA" }
  ];

  const benefits = [
    { icon: <Award className="h-6 w-6" />, title: "Reconocimiento internacional de calidad", description: "Certificación respaldada por estándares globales" },
    { icon: <TrendingUp className="h-6 w-6" />, title: "Mejoramiento continuo de procesos educativos", description: "Desarrollo profesional permanente" },
    { icon: <Users className="h-6 w-6" />, title: "Fortalecimiento del perfil docente digital", description: "Competencias para la era digital" },
    { icon: <Globe className="h-6 w-6" />, title: "Red global de educadores certificados", description: "Conexión con comunidad internacional" }
  ];

  const rubros = [
    { title: "Formación académica", description: "Evaluación de credenciales y trayectoria educativa" },
    { title: "Experiencia docente", description: "Análisis de práctica pedagógica demostrable" },
    { title: "Competencia pedagógica", description: "Métodos y estrategias de enseñanza digital" },
    { title: "Evaluación y mejora continua", description: "Sistemas de retroalimentación efectivos" },
    { title: "Investigación y publicaciones", description: "Contribuciones académicas verificables" },
    { title: "Competencias internacionales", description: "Perspectiva global y multicultural" },
    { title: "Desarrollo profesional", description: "Actualización y capacitación permanente" },
    { title: "Innovación tecnológica", description: "Uso creativo de herramientas digitales" },
    { title: "Impacto y reconocimiento", description: "Resultados medibles en el aprendizaje" },
    { title: "Contribuciones académicas", description: "Participación en comunidades educativas" }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-[700px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
            alt="Universidad moderna"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-gray-50/65 to-white/75"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-left">
              <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight text-gray-900">
                Certificación Internacional de
                <span className="text-orange-600 block">
                  Competencias y Habilidades para la Docencia en Línea
                </span>
              </h1>

              <p className="text-xl md:text-2xl text-gray-700 mb-8 leading-relaxed">
                Transformando la educación superior a través de la excelencia y la innovación en la enseñanza digital
              </p>

              <p className="text-lg text-gray-600 mb-12 max-w-2xl">
                Únete al movimiento global de docentes comprometidos con la calidad educativa y el bienestar estudiantil en el ámbito digital.
              </p>

              {/* CTA Buttons */}
                      <div className="flex flex-col sm:flex-row gap-4">
                      <Link
                        to="/contacto"
                        className="inline-flex items-center px-8 py-4 bg-red-800 text-white font-semibold rounded-lg hover:bg-red-900 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                      >
                        Iniciar Certificación
                        <ArrowRight className="ml-2 h-5 w-5" />
                      </Link>
                      <Link
                        to="/certificacion"
                        className="inline-flex items-center px-8 py-4 bg-white border-2 border-red-800 text-red-800 hover:bg-red-50 transition-all duration-300 shadow-md"
                      >
                        Conocer el Proceso
                        <BookOpen className="ml-2 h-5 w-5" />
                      </Link>
                      </div>
                    </div>

                    {/* Logo Section */}
            <div className="flex justify-center lg:justify-end">
              <img
                src="https://customer-assets.emergentagent.com/job_6d561d89-c6ed-4e1a-837f-2a343ad92f4b/artifacts/py5s4u20_cdl_naraja.png"
                alt="GRANA Certification Logo"
                className="w-64 h-64 object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ¿Qué es GRANA? */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              ¿Qué es la Certificación GRANA?
            </h2>
            <div className="w-24 h-1 bg-orange-600 mx-auto mb-8"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                La Certificación Internacional de Competencias y Habilidades para la Docencia en Línea
                representa un esfuerzo pionero de <strong>GRANA</strong> (Generation of Resources for Accreditation in Nations of the America)
                para consolidar estándares de calidad en la enseñanza virtual.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Nuestro objetivo es reconocer y acreditar a los docentes que demuestran dominio pedagógico,
                innovación tecnológica y compromiso social en el ámbito digital, integrando la promoción
                de la excelencia educativa en todas sus funciones sustantivas: docencia, investigación y extensión.
              </p>

              <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-orange-600">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Misión</h3>
                <p className="text-gray-700">
                  Impulsar la calidad, pertinencia e innovación educativa mediante procesos de
                  evaluación, acreditación y certificación internacional.
                </p>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Visión</h3>
                <p className="text-gray-700">
                  Ser referente global en la certificación académica, garantizando que los docentes
                  estén preparados para los desafíos de la educación digital y la transformación social.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Alcance Global</h3>
                <p className="text-gray-700">
                  GRANA trabaja con instituciones, programas y profesionales de la educación superior
                  en América y el mundo, fortaleciendo una comunidad de práctica con estándares
                  comparables internacionalmente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ¿Por qué certificarse? */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-8">
                ¿Por qué certificarse con GRANA?
              </h2>
              <div className="space-y-6">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-4 p-4 bg-green-50 rounded-lg">
                    <div className="text-green-600 flex-shrink-0 mt-1">
                      <CheckCircle className="h-6 w-6" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-800">{benefit.title}</h3>
                      <p className="text-gray-600 mt-1">{benefit.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="bg-red-900 rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-8 text-center text-orange-400">
                Modelo de Evaluación Integral
              </h3>
              <div className="grid grid-cols-2 gap-6">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-4xl font-bold text-orange-400 mb-2">
                      {stat.number}
                    </div>
                    <div className="text-red-100 font-medium">
                      {stat.label}
                    </div>
                    <div className="text-red-200 text-sm">
                      {stat.sublabel}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Diez Rubros de Evaluación */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            Diez Rubros de Evaluación Integral
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nuestro modelo se fundamenta en diez pilares esenciales que garantizan
            un enfoque integral de la excelencia en la docencia digital.
          </p>
          <div className="w-24 h-1 bg-orange-600 mx-auto mt-6"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {rubros.map((rubro, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="text-center mb-4">
            <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center mx-auto mb-3 text-xl font-bold">
              {String(index + 1).padStart(2, '0')}
            </div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              {rubro.title}
            </h3>
              </div>
              <p className="text-gray-600 text-sm text-center">
            {rubro.description}
              </p>
            </div>
          ))}
            </div>

            <div className="text-center mt-12">
          <Link
            to="/certificacion"
            className="inline-flex items-center px-8 py-4 bg-red-800 text-white font-semibold rounded-lg hover:bg-red-900 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <GraduationCap className="mr-2 h-5 w-5" />
            Conoce el Proceso Completo
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
            </div>
          </div>
        </section>

        {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-slate-50 to-gray-50 rounded-2xl border border-gray-200 p-10 relative overflow-hidden">
            {/* Subtle decorative element */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-orange-50 to-transparent rounded-full -translate-y-32 translate-x-32 opacity-60"></div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
              {/* Content */}
              <div>
                <h2 className="text-3xl font-semibold text-gray-900 mb-4 leading-tight">
                  Soporte Académico Especializado
                </h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Nuestro equipo de consultores académicos está disponible para guiarte 
                  en cada etapa del proceso de certificación internacional.
                </p>
                
                {/* Services list - more professional */}
                <div className="space-y-4 mb-8">
                  <div className="flex items-center text-gray-700">
                    <div className="w-1.5 h-1.5 bg-orange-500 rounded-full mr-4 flex-shrink-0"></div>
                    <span className="text-base font-medium">Consultoría personalizada individual</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <div className="w-1.5 h-1.5 bg-orange-500 rounded-full mr-4 flex-shrink-0"></div>
                    <span className="text-base font-medium">Asistencia técnica especializada</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <div className="w-1.5 h-1.5 bg-orange-500 rounded-full mr-4 flex-shrink-0"></div>
                    <span className="text-base font-medium">Sesiones de preparación grupales</span>
                  </div>
                </div>

                {/* CTA Button */}
                <a
                  href={
                    /Mobi|Android/i.test(navigator.userAgent)
                      ? "https://wa.me/+523173851203?text=Requiero informacion sobre el programa"
                      : "https://web.whatsapp.com/send?phone=+523173851203&text=Requiero informacion sobre el programa"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-3 bg-red-800 text-white font-medium rounded-lg hover:bg-red-900 transition-colors duration-200 shadow-sm hover:shadow-md"
                >
                  Solicitar Consultoría
                  <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </div>

              {/* Stats or Visual Element */}
              <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100">
                <div className="text-center mb-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Proceso de Certificación
                  </h3>
                  <p className="text-sm text-gray-600">
                    Metodología estructurada en etapas
                  </p>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center text-sm font-semibold mr-3">
                      1
                    </div>
                    <span className="text-sm text-gray-700">Evaluación inicial de requisitos</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center text-sm font-semibold mr-3">
                      2
                    </div>
                    <span className="text-sm text-gray-700">Documentación y portfolio académico</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center text-sm font-semibold mr-3">
                      3
                    </div>
                    <span className="text-sm text-gray-700">Revisión por pares especializados</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center text-sm font-semibold mr-3">
                      ✓
                    </div>
                    <span className="text-sm text-gray-700">Certificación internacional</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;